import React, { useEffect, useState } from 'react';
import { useOktaAuth } from '@okta/okta-react';
import { toRelativeUrl } from '@okta/okta-auth-js';
import { Outlet } from 'react-router-dom';
import LoaderComponent from './LoaderComponent';
import swal from 'sweetalert';


export const RequiredAuth = () => {
  const { oktaAuth, authState } = useOktaAuth();
  const [showLoader,setShowLoader] = useState(false);
  useEffect(() => {
    if (!authState) {
      return;
    }
    if (!authState?.isAuthenticated) {
      const originalUri = toRelativeUrl(window.location.href, window.location.origin);
      oktaAuth.setOriginalUri(originalUri);
      oktaAuth.signInWithRedirect();
      return;
    }
    // console.log('authState',authState)
  // }, [oktaAuth, authState]);
  }, [oktaAuth, !!authState, authState?.isAuthenticated]);

  if (!authState || !authState?.isAuthenticated) {
   //return (<Loading />);
   return (<LoaderComponent />);
  }

  // Commenting for now will add again with kohler or rehlko email address  

  if(authState || authState?.isAuthenticated){
    let userEmail = authState?.accessToken?.claims?.sub.split('@');
    if(userEmail && !userEmail[1].includes('rehlko.com')){
      if(showLoader){
        return (<LoaderComponent />);
      }
      if(!showLoader){
        swal({
            title: "Error",
            text: 'Access Denied!',
            icon: "error",
            closeOnClickOutside:false,
            closeOnEsc: false,
            allowOutsideClick: false,
        })
        .then(marked => {
          if (marked) {
            setShowLoader(true);
            oktaAuth.signOut();
          }
        });
      }
    } else {
      return (<Outlet />);
    }
    
  }
  
  //return (<Outlet />);
}